function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useMutation, useQuery, useLazyQuery } from "@apollo/client";
import format from "date-fns/format";
import isSameDay from "date-fns/isSameDay";
import isToday from "date-fns/isToday";
import isYesterday from "date-fns/isYesterday";
import React from "react";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { HiOutlineX, HiOutlineDotsVertical, HiArrowDown, HiArrowUp, HiOutlineArrowNarrowUp, HiOutlineArrowNarrowDown, HiOutlineClock } from "react-icons/hi";
import { GoChevronLeft, GoChevronRight, GoCalendar, GoChevronDown } from "react-icons/go";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { FilterContext, UserContext, SearchContext } from "../index";
import UserSidemenu from "../SideMenu/UserSidemenu";
import Loader from "./../Loader/Loader";
import { DELETE_SCREENSHOT_MUTATION, DELETE_BULK_SCREENSHOT_MUTATION, SCREENSHOT_DATA_QUERY, SCREENSHOT_DATA_EXPORT_QUERY, ADD_SCREENSHOT_WORK_DAY_SETTINGS_MUTATION } from "./query";
import { WEB_ORGANISATION_SETTINGS_QUERY, WORK_DAY_SETTINGS_QUERY } from "../TimesheetSettings/query";
import "./ScreenShots.css";
import classNames from "classnames";
import { findIsWorkfolioSite } from "../utils";
import { toast } from "react-toastify";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import SearchBar from "../SearchBar";
import DatePicker from "react-datepicker";
import Popover from "react-bootstrap/Popover";
import TimePicker from "rc-time-picker";
import { arrayToStringOutput, stringToArrayOutput } from "./../SideMenu/Header";
import { MdOutlineAccessTime, MdClose, MdKeyboard, MdKeyboardAlt, MdMouse } from "react-icons/md";
import { IoMdTime } from "react-icons/io";
import { BillingDueExtendedMsg, BillingBankTrasferPlanEndBeforeMsg } from "./../Billing/Billing";
import { RiComputerLine } from "react-icons/ri";
import Badge from "react-bootstrap/Badge";
var fs = require("fs");

//test

var moment = require("moment-timezone");
var LIMIT = 20;

// The backend pages screenshots_link one day at a time (its only index is on
// added_at, so OFFSET made every page re-walk the ones before it). "start" asks
// for the first page; after that we hand back the nextCursor it returns.
var FIRST_PAGE_CURSOR = "start";

// how many empty pages in a row we will walk through on our own before waiting
// for the user again, so a backend that always reports hasMore cannot spin
var MAX_AUTO_ADVANCE = 10;
var ScreenShots = function ScreenShots(props) {
  var _match$params, _screenShotData$scree5, _activityLevelList$fi, _screenShotData$scree17, _screenShotData$scree18, _screenShotData$scree19, _screenShotData$scree20, _screenShotData$scree21, _screenShotData$scree22, _screenShotData$scree23, _screenShotData$scree24, _screenShotData$scree25, _screenShotData$scree26, _screenShotData$scree29, _screenShotData$scree30, _screenShotData$scree31, _screenShotData$scree32;
  var match = props.match,
    Redirect = props.redirect,
    organisationId = props.organisationId,
    teamId = props.teamId,
    startDate = props.startDate,
    endDate = props.endDate,
    organisationSettings = props.organisationSettings,
    role = props.role,
    from = props.from,
    planId = props.planId,
    Link = props.linkComponent,
    linkProps = props.linkProps,
    planName = props.planName,
    organisationBilling = props.organisationBilling;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    ImageViewerShow = _React$useState2[0],
    setImageViewerShow = _React$useState2[1];
  var _React$useState3 = React.useState(0),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    ImageViewerNextNavCount = _React$useState4[0],
    setImageViewerNextNavCount = _React$useState4[1];
  var _React$useState5 = React.useState(0),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    ImageViewerPrevNavCount = _React$useState6[0],
    setImageViewerPrevNavCount = _React$useState6[1];
  var _React$useState7 = React.useState(null),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    showDeleteModal = _React$useState8[0],
    setShowDeleteModal = _React$useState8[1];
  var _React$useState9 = React.useState(null),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    showBulkDeleteModal = _React$useState10[0],
    setShowBulkDeleteModal = _React$useState10[1];

  // load more state
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    isAllLoaded = _React$useState12[0],
    setIsAllLoaded = _React$useState12[1];
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    isLoadingMore = _React$useState14[0],
    setIsLoadingMore = _React$useState14[1];

  // guards against a second page being requested while one is in flight (this
  // replaces a module-level counter that every mounted instance of this screen
  // used to share)
  var inFlightRef = React.useRef(false);
  var _React$useState15 = React.useState(false),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    isLoadMoreButton = _React$useState16[0],
    setIsLoadMoreButton = _React$useState16[1];
  var _React$useState17 = React.useState("desc"),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    sortBy = _React$useState18[0],
    setSortBy = _React$useState18[1];
  var _React$useState19 = React.useState([]),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    urls = _React$useState20[0],
    setUrls = _React$useState20[1];
  var _React$useState21 = React.useState([]),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    urlIds = _React$useState22[0],
    setUrlIds = _React$useState22[1];
  var _React$useState23 = React.useState([]),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    thumbnailUrls = _React$useState24[0],
    setThumbnailUrls = _React$useState24[1];
  var _React$useState25 = React.useState(false),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    exportLoad = _React$useState26[0],
    setExportLoad = _React$useState26[1];
  var _React$useState27 = React.useState(null),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    exportValue = _React$useState28[0],
    setExportValue = _React$useState28[1];
  var _React$useState29 = React.useState("unchecked"),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    selectAllButton = _React$useState30[0],
    setSelectAllButton = _React$useState30[1];
  var _React$useContext = React.useContext(SearchContext),
    search = _React$useContext.search,
    setSearch = _React$useContext.setSearch;
  var _React$useState31 = React.useState(new Date()),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    startDateFilter = _React$useState32[0],
    setStartDateFilter = _React$useState32[1];
  var _React$useState33 = React.useState(null),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    endDateFilter = _React$useState34[0],
    setEndDateFilter = _React$useState34[1];
  var _React$useState35 = React.useState(arrayToStringOutput([startDateFilter, endDateFilter], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    filterData = _React$useState36[0],
    setFilterData = _React$useState36[1];
  var _React$useState37 = React.useState(moment().startOf("day")),
    _React$useState38 = _slicedToArray(_React$useState37, 2),
    startTimeFilter = _React$useState38[0],
    setStartTimeFilter = _React$useState38[1];
  var _React$useState39 = React.useState(moment().endOf("day")),
    _React$useState40 = _slicedToArray(_React$useState39, 2),
    endTimeFilter = _React$useState40[0],
    setEndTimeFilter = _React$useState40[1];
  var _React$useState41 = React.useState(false),
    _React$useState42 = _slicedToArray(_React$useState41, 2),
    showFilter = _React$useState42[0],
    setShowFilter = _React$useState42[1];
  var _React$useState43 = React.useState(moment().startOf("day")),
    _React$useState44 = _slicedToArray(_React$useState43, 2),
    startTimeTemp = _React$useState44[0],
    setStartTimeTemp = _React$useState44[1];
  var _React$useState45 = React.useState(moment().endOf("day")),
    _React$useState46 = _slicedToArray(_React$useState45, 2),
    endTimeTemp = _React$useState46[0],
    setEndTimeTemp = _React$useState46[1];
  var _React$useState47 = React.useState(moment().toDate()),
    _React$useState48 = _slicedToArray(_React$useState47, 2),
    startDateTemp = _React$useState48[0],
    setStartDateTemp = _React$useState48[1];
  var _React$useState49 = React.useState(moment().toDate()),
    _React$useState50 = _slicedToArray(_React$useState49, 2),
    endDateTemp = _React$useState50[0],
    setEndDateTemp = _React$useState50[1];
  var _React$useState51 = React.useState(false),
    _React$useState52 = _slicedToArray(_React$useState51, 2),
    isIdleCheck = _React$useState52[0],
    setIsIdleCheck = _React$useState52[1];
  var _React$useState53 = React.useState(null),
    _React$useState54 = _slicedToArray(_React$useState53, 2),
    activityLevel = _React$useState54[0],
    setActivityLevel = _React$useState54[1];
  var siteName = findIsWorkfolioSite();
  var targetRef = React.useRef(null);
  React.useEffect(function () {
    setFilterData(arrayToStringOutput([startDateFilter, endDateFilter], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone));
  }, [startDateFilter, endDateFilter]);
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;
  var deleteCheck = organisationSettings.allowMemberToAccessScreenCapture === true && organisationSettings.allowMemberToDeleteScreenCapture === true;
  var url = (_match$params = match.params) === null || _match$params === void 0 ? void 0 : _match$params.url;
  React.useEffect(function () {
    setIsAllLoaded(false);
    inFlightRef.current = false;
  }, [url, startDate, teamId, search, startDateFilter, endDateFilter, startTimeFilter, endTimeFilter, isIdleCheck]);
  React.useEffect(function () {
    setUrls([]);
    setUrlIds([]);
    setSelectAllButton("unchecked");
    setThumbnailUrls([]);
  }, [url, startDate, teamId, props.location.key, sortBy, isIdleCheck, startDateFilter, endDateFilter, startTimeFilter, endTimeFilter, search]);

  // console.log({ startDate, endDate });

  var startDateUnix = Number(moment(startDate).format("x"));
  var endDateUnix = Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x"));

  // console.log({ startDateUnix, endDateUnix });

  var _useQuery = useQuery(SCREENSHOT_DATA_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userId: role === "Member" || role === "Head" && !organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo ? user.userId : null,
        url: role !== "Member" || role === "Head" && organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo ? url : null,
        limit: LIMIT,
        offset: 0,
        cursor: FIRST_PAGE_CURSOR,
        startDate: startDateUnix,
        endDate: endDateUnix,
        sortBy: sortBy,
        userRole: role,
        search: search,
        startTime: role != "Member" ? moment(startTimeFilter).format("HH:mm") : null,
        endTime: role != "Member" ? moment(endTimeFilter).format("HH:mm") : null,
        tz: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        screenshotType: isIdleCheck ? "idle" : "all",
        activityLevel: activityLevel
      },
      // fetchPolicy: "network-only",
      // notifyOnNetworkStatusChange: true,
      skip: !organisationId || !teamId
    }),
    screenShotData = _useQuery.data,
    screenShotError = _useQuery.error,
    screenShotLoading = _useQuery.loading,
    fetchMore = _useQuery.fetchMore,
    networkStatus = _useQuery.networkStatus,
    refetch = _useQuery.refetch;
  var _useLazyQuery = useLazyQuery(SCREENSHOT_DATA_EXPORT_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportLoad(false);
      }
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getExport = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    exportLoading = _useLazyQuery2$.loading,
    exportData = _useLazyQuery2$.data;
  var handleZipFile = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var count, zip, i, sliceSize, byteCharacters, byteArrays, offset, slice, byteNumbers, _i, byteArray, blob, imageFile, arrSplit, filename, currDate, dateWithOffset;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (exportData) {
            count = 0;
            zip = new JSZip();
            for (i = 0; i < exportData.screenshotDataExport.length; i++) {
              sliceSize = 512;
              byteCharacters = atob(exportData.screenshotDataExport[i]);
              byteArrays = [];
              for (offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                slice = byteCharacters.slice(offset, offset + sliceSize);
                byteNumbers = new Array(slice.length);
                for (_i = 0; _i < slice.length; _i++) {
                  byteNumbers[_i] = slice.charCodeAt(_i);
                }
                byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
              }
              blob = new Blob(byteArrays, {
                type: "image/png"
              });
              imageFile = new File([blob], "filename.jpg");
              arrSplit = urls[i].split("/");
              filename = arrSplit[arrSplit.length - 1];
              filename = filename.split("?")[0];
              currDate = new Date();
              dateWithOffset = new Date(currDate.getTime() - currDate.getTimezoneOffset() * 60000);
              zip.file(filename, imageFile, {
                binary: true,
                date: dateWithOffset
              });
              count++;
              if (count === exportData.screenshotDataExport.length) {
                /* Generate a zip file asynchronously and trigger the download */
                zip.generateAsync({
                  type: "blob"
                }).then(function (content) {
                  return saveAs(content, "".concat(siteName, "-screenshots"));
                });
              }
            }
            setExportLoad(false);
          }
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [exportData]);
  React.useEffect(function () {
    handleZipFile();
    setExportValue(exportData);
  }, [exportData]);
  React.useEffect(function () {
    if (selectAllButton === "checked") {
      setUrls([]);
      setThumbnailUrls([]);
      var screenArr = [];
      var screenId = [];
      var screenThumbUrl = [];
      for (var index = 0; index < (screenShotData === null || screenShotData === void 0 ? void 0 : (_screenShotData$scree = screenShotData.screenshots) === null || _screenShotData$scree === void 0 ? void 0 : (_screenShotData$scree2 = _screenShotData$scree.Screenshot) === null || _screenShotData$scree2 === void 0 ? void 0 : _screenShotData$scree2.length); index++) {
        var _screenShotData$scree, _screenShotData$scree2, _screenShotData$scree3;
        var element = screenShotData === null || screenShotData === void 0 ? void 0 : (_screenShotData$scree3 = screenShotData.screenshots) === null || _screenShotData$scree3 === void 0 ? void 0 : _screenShotData$scree3.Screenshot[index];
        screenArr.push(element === null || element === void 0 ? void 0 : element.imageUrl);
        screenId.push(element.screenshotId);
        screenThumbUrl.push(element.thumbnailUrl);
      }
      setUrls(screenArr);
      setUrlIds(screenId);
      setThumbnailUrls(screenThumbUrl);
    } else {
      setUrls([]);
      setUrlIds([]);
      setThumbnailUrls([]);
    }
  }, [selectAllButton]);
  React.useEffect(function () {
    refetch === null || refetch === void 0 ? void 0 : refetch();
  }, [props.location.key, url]);
  React.useEffect(function () {
    refetch === null || refetch === void 0 ? void 0 : refetch();
  }, [sortBy]);
  if (role === "Head" && !organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo && !organisationSettings.allowMemberToAccessScreenCapture || role === "Member" && !organisationSettings.screenCapture) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/"
    });
  }

  // isAllLoaded mirrors the server's hasMore. A short page no longer means the
  // end of the list: the backend pages a couple of days at a time, so it can
  // return fewer than LIMIT rows with older days still to come. Following
  // hasMore in both directions also unsticks the list after a delete refetch,
  // which resets it to the first page.
  React.useEffect(function () {
    var _screenShotData$scree4;
    var hasMore = screenShotData === null || screenShotData === void 0 ? void 0 : (_screenShotData$scree4 = screenShotData.screenshots) === null || _screenShotData$scree4 === void 0 ? void 0 : _screenShotData$scree4.hasMore;
    if (hasMore === undefined || hasMore === null) return;
    setIsAllLoaded(!hasMore);
  }, [screenShotData === null || screenShotData === void 0 ? void 0 : (_screenShotData$scree5 = screenShotData.screenshots) === null || _screenShotData$scree5 === void 0 ? void 0 : _screenShotData$scree5.hasMore]);
  var handleClose = function handleClose() {
    var _screenShotData$scree6, _screenShotData$scree7;
    setImageViewerShow(false);
    setImageViewerShow(null);
    setImageViewerNextNavCount(0);
    setImageViewerPrevNavCount((screenShotData === null || screenShotData === void 0 ? void 0 : (_screenShotData$scree6 = screenShotData.screenshots) === null || _screenShotData$scree6 === void 0 ? void 0 : (_screenShotData$scree7 = _screenShotData$scree6.Screenshot) === null || _screenShotData$scree7 === void 0 ? void 0 : _screenShotData$scree7.length) - 1);
  };
  var handleShow = function handleShow(value, index) {
    var _screenShotData$scree8, _screenShotData$scree9;
    var temp = _objectSpread(_objectSpread({}, value), {}, {
      index: index
    });
    setImageViewerShow(temp);
    setImageViewerPrevNavCount((screenShotData === null || screenShotData === void 0 ? void 0 : (_screenShotData$scree8 = screenShotData.screenshots) === null || _screenShotData$scree8 === void 0 ? void 0 : (_screenShotData$scree9 = _screenShotData$scree8.Screenshot) === null || _screenShotData$scree9 === void 0 ? void 0 : _screenShotData$scree9.length) - 1);
  };
  var handleNext = function handleNext() {
    var _screenShotData$scree10, _screenShotData$scree11, _screenShotData$scree12;
    var index = ImageViewerShow.index;
    index = Number(index) + 1;
    setImageViewerNextNavCount(index);
    var temp = _objectSpread(_objectSpread({}, screenShotData === null || screenShotData === void 0 ? void 0 : (_screenShotData$scree10 = screenShotData.screenshots) === null || _screenShotData$scree10 === void 0 ? void 0 : _screenShotData$scree10.Screenshot[index]), {}, {
      index: index
    });
    if ((screenShotData === null || screenShotData === void 0 ? void 0 : (_screenShotData$scree11 = screenShotData.screenshots) === null || _screenShotData$scree11 === void 0 ? void 0 : (_screenShotData$scree12 = _screenShotData$scree11.Screenshot) === null || _screenShotData$scree12 === void 0 ? void 0 : _screenShotData$scree12.length) < index) {
      setImageViewerShow(null);
    }
    setImageViewerShow(temp);
  };
  var handlePrevious = function handlePrevious() {
    var _screenShotData$scree13, _screenShotData$scree14, _screenShotData$scree15;
    var index = ImageViewerShow.index;
    index = Number(index) - 1;
    setImageViewerPrevNavCount(index);
    var temp = _objectSpread(_objectSpread({}, screenShotData === null || screenShotData === void 0 ? void 0 : (_screenShotData$scree13 = screenShotData.screenshots) === null || _screenShotData$scree13 === void 0 ? void 0 : _screenShotData$scree13.Screenshot[index]), {}, {
      index: index
    });
    if ((screenShotData === null || screenShotData === void 0 ? void 0 : (_screenShotData$scree14 = screenShotData.screenshots) === null || _screenShotData$scree14 === void 0 ? void 0 : (_screenShotData$scree15 = _screenShotData$scree14.Screenshot) === null || _screenShotData$scree15 === void 0 ? void 0 : _screenShotData$scree15.length) > index) {
      setImageViewerShow(null);
    }
    setImageViewerShow(temp);
  };
  function loadNextPage(cursorOverride) {
    var _ref2, _screenShotData$scree16;
    var autoAdvance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (screenShotLoading || isAllLoaded || inFlightRef.current) return;

    // the merged cache carries the latest nextCursor (see updateQuery below); the
    // override is for walking several pages before a re-render has happened
    var cursor = (_ref2 = cursorOverride !== null && cursorOverride !== void 0 ? cursorOverride : screenShotData === null || screenShotData === void 0 ? void 0 : (_screenShotData$scree16 = screenShotData.screenshots) === null || _screenShotData$scree16 === void 0 ? void 0 : _screenShotData$scree16.nextCursor) !== null && _ref2 !== void 0 ? _ref2 : FIRST_PAGE_CURSOR;
    inFlightRef.current = true;
    setIsLoadingMore(true);
    fetchMore({
      variables: {
        cursor: cursor
      },
      // fetchPolicy: 'network-only',
      // notifyOnNetworkStatusChange: true,
      updateQuery: function updateQuery(prev, _ref3) {
        var _next$nextCursor, _next$hasMore, _prev$screenshots$Scr, _prev$screenshots, _next$Screenshot;
        var fetchMoreResult = _ref3.fetchMoreResult;
        setIsLoadingMore(false);
        if (!fetchMoreResult) return prev;
        var next = fetchMoreResult.screenshots;

        // stop on hasMore, not on an empty page: the backend pages a couple of
        // days at a time, so a page can come back empty while older days still
        // hold screenshots
        if ((next === null || next === void 0 ? void 0 : next.hasMore) === false && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        return _objectSpread(_objectSpread({}, prev), {}, {
          screenshots: _objectSpread(_objectSpread({}, prev === null || prev === void 0 ? void 0 : prev.screenshots), {}, {
            // must come from the new page, not from prev, or the next scroll
            // would ask for this same page again
            nextCursor: (_next$nextCursor = next === null || next === void 0 ? void 0 : next.nextCursor) !== null && _next$nextCursor !== void 0 ? _next$nextCursor : null,
            hasMore: (_next$hasMore = next === null || next === void 0 ? void 0 : next.hasMore) !== null && _next$hasMore !== void 0 ? _next$hasMore : false,
            Screenshot: [].concat(_toConsumableArray((_prev$screenshots$Scr = prev === null || prev === void 0 ? void 0 : (_prev$screenshots = prev.screenshots) === null || _prev$screenshots === void 0 ? void 0 : _prev$screenshots.Screenshot) !== null && _prev$screenshots$Scr !== void 0 ? _prev$screenshots$Scr : []), _toConsumableArray((_next$Screenshot = next === null || next === void 0 ? void 0 : next.Screenshot) !== null && _next$Screenshot !== void 0 ? _next$Screenshot : []))
          })
        });
      }
    }).then(function (res) {
      var _res$data, _next$Screenshot$leng, _next$Screenshot2;
      inFlightRef.current = false;
      var next = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.screenshots;

      // nothing was appended, so no scroll event will arrive to ask for the
      // next page - keep walking the range ourselves until something lands
      if (next !== null && next !== void 0 && next.hasMore && ((_next$Screenshot$leng = next === null || next === void 0 ? void 0 : (_next$Screenshot2 = next.Screenshot) === null || _next$Screenshot2 === void 0 ? void 0 : _next$Screenshot2.length) !== null && _next$Screenshot$leng !== void 0 ? _next$Screenshot$leng : 0) === 0 && autoAdvance < MAX_AUTO_ADVANCE) {
        loadNextPage(next === null || next === void 0 ? void 0 : next.nextCursor, autoAdvance + 1);
      }
    })["catch"](function () {
      inFlightRef.current = false;
      setIsLoadingMore(false);
    });
  }
  function handleScroll(e) {
    var element = e.target;
    if (Math.ceil(element.scrollHeight - element.scrollTop) === element.clientHeight) {
      loadNextPage();
    }
  }
  var handleLoadMore = function handleLoadMore() {
    loadNextPage();
  };
  var handleDelete = function handleDelete() {};

  /*****  DELEET SHOW & CLOSE ***/
  var handleDeleteClose = function handleDeleteClose() {
    setShowDeleteModal(null);
    setSelectAllButton("unchecked");
  };
  var handleBulkDeleteClose = function handleBulkDeleteClose() {
    setShowBulkDeleteModal(null);
    setSelectAllButton("unchecked");
  };
  var handleDeleteShow = function handleDeleteShow(screenshotValue) {
    var temp = _objectSpread(_objectSpread({}, screenshotValue), {}, {
      organisationId: organisationId,
      teamId: teamId
    });
    setShowDeleteModal(temp);
  };
  var handleBulkDeleteShow = function handleBulkDeleteShow() {
    //const temp = { screenshotId, appTitle, organisationId, teamId };
    if (urlIds.length !== 0) {
      setShowBulkDeleteModal(true);
    }
  };
  var editButtonForMember = role != "Admin" && deleteCheck;
  var editButtonAdminForMember = role === "Admin";
  var editButtonHeadForMember = role === "Head" && organisationSettings.allowHeadToDeleteTeamMemberScreenCapture === true;
  var selectedImageUrl = function selectedImageUrl(url, ids, thumbnailUrl) {
    setUrls(function (prev) {
      return prev.includes(url) ? prev.filter(function (a) {
        return a !== url;
      }) : [].concat(_toConsumableArray(prev), [url]);
    });
    setUrlIds(function (prev) {
      return prev.includes(ids) ? prev.filter(function (a) {
        return a !== ids;
      }) : [].concat(_toConsumableArray(prev), [ids]);
    });
    setThumbnailUrls(function (prev) {
      return prev.includes(thumbnailUrl) ? prev.filter(function (a) {
        return a !== thumbnailUrl;
      }) : [].concat(_toConsumableArray(prev), [thumbnailUrl]);
    });
  };
  var selectAll = function selectAll(e) {
    if (selectAllButton === "checked") {
      setSelectAllButton("unchecked");
    } else {
      setSelectAllButton("checked");
    }
  };
  var getExportData = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var arr, i, t;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (urls.length !== 0) {
              setExportLoad(true);
              arr = [];
              for (i = 0; i < urls.length; i++) {
                t = urls[i];
                if (urls[i].includes("s3")) {
                  // let splitArr = urls[i].split(`/${planName}-screenshots`);

                  // t = `${planName}-screenshots` + splitArr[1];

                  // Use URL API to dynamically remove domain & protocol
                  t = new URL(urls[i]).pathname.replace(/^\/+/, ""); // remove leading slash
                }

                // https://free-screenshots.s3.ap-south-1.amazonaws.com/f16d0e90-380a-11f0-baee-6d290d60da91.png
                // else {
                //   // let splitArr = urls[i].split(`getworkfolio.com/`);

                //   // t = splitArr[1];
                // }

                arr.push(t);
              }
              getExport({
                variables: {
                  screenshotUrls: arr
                }
              });
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getExportData() {
      return _ref4.apply(this, arguments);
    };
  }();
  var currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // let activityLevelList = [
  //   { label: "All Activity", value: "all" },
  //   { label: "Low (Less than 20 movements)", value: "low" },
  //   { label: "Medium (20 to 39 movements)", value: "medium" },
  //   { label: "High (Above 40 movements)", value: "high" },
  // ];

  var activityLevelList = [{
    label: "All Activity",
    value: "all"
  }, {
    label: "Low",
    value: "low"
  }, {
    label: "Medium",
    value: "medium"
  }, {
    label: "High",
    value: "high"
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "screenshots-card-wrapper",
    style: from === "desktop" ? {
      overflowY: "hidden",
      height: "auto"
    } : null
    //onScroll={(e) => handleScroll(e)}
  }, (!organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo && !organisationSettings.allowMemberToAccessScreenCapture && role == "Head" || !organisationSettings.screenCapture && (role == "Member" || role == "Admin")) && from === "web" ? /*#__PURE__*/React.createElement(ScreenShotEnableSection, {
    organisationId: organisationId,
    teamId: teamId,
    role: role,
    user: user,
    url: url,
    startDate: Number(moment(startDate).format("x")),
    endDate: Number(moment(startDate).format("x")),
    sortBy: sortBy,
    startDateFilter: startDateFilter,
    endDateFilter: endDateFilter,
    organisationSettings: organisationSettings,
    isIdleCheck: isIdleCheck,
    startTimeFilter: startTimeFilter,
    endTimeFilter: endTimeFilter,
    search: search,
    activityLevel: activityLevel
  }) : /*#__PURE__*/React.createElement("div", {
    className: "screenshots-card"
  }, role != "Member" ? /*#__PURE__*/React.createElement(BillingDueExtendedMsg, {
    failedPlanEnd: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.failedPlanEnd,
    billingPeriodEnd: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.billingPeriodEnd,
    handleCheckout: null,
    pageName: "dashboard",
    planStatus: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus,
    history: props === null || props === void 0 ? void 0 : props.history
  }) : null, role != "Member" ? /*#__PURE__*/React.createElement(BillingBankTrasferPlanEndBeforeMsg, {
    beforePlanEndAlert: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.beforePlanEndAlert,
    planEnd: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planEnd,
    planStatus: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus,
    paymentType: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.paymentType
  }) : null, from === "web" ? /*#__PURE__*/React.createElement("p", {
    className: "screenshots-card-note-text"
  }, "Note: If the user is inactive, screenshots taken during that time will have a red border.") : null, from === "web" && role != "Member" ? /*#__PURE__*/React.createElement("div", {
    className: "screenshots-card-export-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshots-card-filter-div"
  }, from === "web" && planName != "free" ? /*#__PURE__*/React.createElement("div", {
    className: "screenshots-card-searchbar-div"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    value: search,
    onChange: setSearch,
    placeholder: "Search by typing the app or site name",
    className: "screenshots-card-searchbar"
  })) : /*#__PURE__*/React.createElement("div", {
    className: "screenshots-card-searchbar-div"
  }, /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to search app or site name")
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement(SearchBar, {
    placeholder: "Search by typing the app or site name",
    className: "screenshots-card-searchbar",
    disabled: true
  }))))), from === "web" && (editButtonForMember || editButtonAdminForMember || editButtonHeadForMember) ? /*#__PURE__*/React.createElement("div", {
    className: "screenshots-card-export-wrapper-div"
  }, planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to select all screenshots")
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshots-card-export-div-select-all disable-screeshots-select-all"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Check, {
    inline: true,
    name: "selectAll",
    type: "checkbox",
    label: "Select All",
    disabled: true
  })))) : /*#__PURE__*/React.createElement("div", {
    className: "screenshots-card-export-div-select-all",
    onClick: function onClick(e) {
      return selectAll(e);
    }
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Check, {
    inline: true,
    name: "selectAll",
    type: "checkbox",
    label: "Select All",
    checked: selectAllButton === "checked",
    onChange: function onChange(e) {
      return selectAll(e);
    },
    className: "screenshots-card-export-div-select-all-form-check"
  }))),
  //  role === "Admin"  ?
  planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export screenshots")
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-download-icon disable-screeshots-export"
  }, "Export")) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "screenshot-download-icon",
    disabled: exportLoad,
    onClick: function onClick() {
      getExportData();
    }
  }, exportLoad ? "Loading" : "Export"), planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to delete multiple screenshots")
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-download-icon disable-screeshots-export"
  }, "Delete")) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "screenshot-download-delete-icon",
    onClick: function onClick() {
      handleBulkDeleteShow();
    }
  }, "Delete")) : null) : null, organisationSettings.keyStrokeCounter == true || organisationSettings.mouseTracker == true ? /*#__PURE__*/React.createElement("div", {
    className: "screenshots-card-sort-dropdown"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Dropdown, {
    onSelect: function onSelect(evt) {
      // const selectedTeamData = organisationTeams.find((team) => team.teamId === evt);
      setActivityLevel(evt);
    }
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    from: from,
    as: CustomToggle
  }, activityLevel ? (_activityLevelList$fi = activityLevelList.find(function (activity) {
    return activity.value == activityLevel;
  })) === null || _activityLevelList$fi === void 0 ? void 0 : _activityLevelList$fi.label : "Filter by Activity", " "), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    className: "workfolio-header-page-content-wrapper-menu-filter-team-menu"
  }, activityLevelList.map(function (item) {
    return /*#__PURE__*/React.createElement(Dropdown.Item, {
      key: item.label,
      eventKey: item.value
    }, item.label);
  })))), /*#__PURE__*/React.createElement("div", {
    className: "screenshots-card-sort-dropdown-wrapper"
  }, role != "Member" ? /*#__PURE__*/React.createElement("div", {
    className: "screenshot-page-toggle-wrapper-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-page-toggle-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-page-setting"
  }, "Idle Screenshots"), /*#__PURE__*/React.createElement("div", {
    className: "screenshot-page-rule-uparrow toggle-switch",
    onClick: function onClick() {
      return setIsIdleCheck(function (prev) {
        return prev === true ? false : true;
      });
    }
  }, /*#__PURE__*/React.createElement("label", {
    "for": "chkTest"
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames("toggle-track", {
      "toggle-track-nav-right-div": isIdleCheck
    })
  }))))) : null, /*#__PURE__*/React.createElement(Dropdown, {
    className: ""
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basics"
  }, sortBy === "asc" ? "Oldest" : "Newest", sortBy === "asc" ? /*#__PURE__*/React.createElement(HiArrowUp, {
    className: "screenshots-card-sort-dropdown-icon"
  }) : /*#__PURE__*/React.createElement(HiArrowDown, {
    className: "screenshots-card-sort-dropdown-icon"
  })), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: function onClick() {
      setSortBy("desc");
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "download-dropdown"
  }, "Newest ", /*#__PURE__*/React.createElement(HiOutlineArrowNarrowDown, null))), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: function onClick() {
      setSortBy("asc");
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "download-dropdown"
  }, "Oldest ", /*#__PURE__*/React.createElement(HiOutlineArrowNarrowUp, null))))))) : /*#__PURE__*/React.createElement("div", {
    className: "screenshots-card-sort-filter-wrapper"
  }, role != "Member" ? /*#__PURE__*/React.createElement("div", {
    className: "screenshot-page-toggle-wrapper-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-page-toggle-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-page-setting"
  }, "Idle Screenshots"), /*#__PURE__*/React.createElement("div", {
    className: "screenshot-page-rule-uparrow toggle-switch",
    onClick: function onClick() {
      return setIsIdleCheck(function (prev) {
        return prev === true ? false : true;
      });
    }
  }, /*#__PURE__*/React.createElement("label", {
    "for": "chkTest"
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames("toggle-track", {
      "toggle-track-nav-right-div": isIdleCheck
    })
  }))))) : null, /*#__PURE__*/React.createElement(Dropdown, {
    className: ""
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basics"
  }, sortBy === "asc" ? "Oldest" : "Newest", sortBy === "asc" ? /*#__PURE__*/React.createElement(HiArrowUp, {
    className: "screenshots-card-sort-dropdown-icon"
  }) : /*#__PURE__*/React.createElement(HiArrowDown, {
    className: "screenshots-card-sort-dropdown-icon"
  })), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: function onClick() {
      setSortBy("desc");
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "download-dropdown"
  }, "Newest ", /*#__PURE__*/React.createElement(HiOutlineArrowNarrowDown, null))), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: function onClick() {
      setSortBy("asc");
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "download-dropdown"
  }, "Oldest ", /*#__PURE__*/React.createElement(HiOutlineArrowNarrowUp, null)))))), screenShotLoading ? /*#__PURE__*/React.createElement("div", {
    className: "ScreenShots-root-data-loader"
  }, /*#__PURE__*/React.createElement(Loader, null)) : screenShotError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : (screenShotData === null || screenShotData === void 0 ? void 0 : (_screenShotData$scree17 = screenShotData.screenshots) === null || _screenShotData$scree17 === void 0 ? void 0 : (_screenShotData$scree18 = _screenShotData$scree17.Screenshot) === null || _screenShotData$scree18 === void 0 ? void 0 : _screenShotData$scree18.length) == 0 && search ? /*#__PURE__*/React.createElement("p", {
    className: "no-screenshot-found"
  }, "No screenshot found for the ".concat(search, " !!!")) : (screenShotData === null || screenShotData === void 0 ? void 0 : (_screenShotData$scree19 = screenShotData.screenshots) === null || _screenShotData$scree19 === void 0 ? void 0 : (_screenShotData$scree20 = _screenShotData$scree19.Screenshot) === null || _screenShotData$scree20 === void 0 ? void 0 : _screenShotData$scree20.length) == 0 && isToday(Number(startDate)) && endDate == null ? /*#__PURE__*/React.createElement("p", {
    className: "no-screenshot-found"
  }, "Yet to capture screenshots") : (screenShotData === null || screenShotData === void 0 ? void 0 : (_screenShotData$scree21 = screenShotData.screenshots) === null || _screenShotData$scree21 === void 0 ? void 0 : (_screenShotData$scree22 = _screenShotData$scree21.Screenshot) === null || _screenShotData$scree22 === void 0 ? void 0 : _screenShotData$scree22.length) == 0 && (activityLevel == 'all' || activityLevel == null) ? /*#__PURE__*/React.createElement("p", {
    className: "no-screenshot-found"
  }, "No screenshots captured") : activityLevel != null && (screenShotData === null || screenShotData === void 0 ? void 0 : (_screenShotData$scree23 = screenShotData.screenshots) === null || _screenShotData$scree23 === void 0 ? void 0 : (_screenShotData$scree24 = _screenShotData$scree23.Screenshot) === null || _screenShotData$scree24 === void 0 ? void 0 : _screenShotData$scree24.length) == 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "no-screenshot-found-1"
  }, "No keyboard or mouse activities were recorded during the selected period."), /*#__PURE__*/React.createElement("p", {
    className: "no-screenshot-found-2"
  }, "This may be because keyboard and mouse tracking was not enabled during that time.")) : /*#__PURE__*/React.createElement("div", {
    className: "ScreenShots-root"
  }, screenShotData === null || screenShotData === void 0 ? void 0 : (_screenShotData$scree25 = screenShotData.screenshots) === null || _screenShotData$scree25 === void 0 ? void 0 : (_screenShotData$scree26 = _screenShotData$scree25.Screenshot) === null || _screenShotData$scree26 === void 0 ? void 0 : _screenShotData$scree26.map(function (screenShotvalue, key) {
    var _screenShotData$scree27, _screenShotData$scree28, _screenShotvalue$disp, _screenShotvalue$disp2, _screenShotvalue$disp3, _screenShotvalue$disp4, _screenShotvalue$disp5, _screenShotvalue$disp6, _screenShotvalue$disp7, _screenShotvalue$disp8;
    // console.log({
    //   addedAt: screenShotvalue?.addedAt,
    //   isToday:
    //     moment().format("MMM DD YYYY") == moment(Number(screenShotvalue?.addedAt)).format("MMM DD YYYY"),
    //   isYesterday:
    //     moment().subtract(1, "days").format("MMM DD YYYY") ==
    //     moment(Number(screenShotvalue?.addedAt)).format("MMM DD YYYY"),
    // });
    return /*#__PURE__*/React.createElement(React.Fragment, null, key === 0 || moment(Number(screenShotData === null || screenShotData === void 0 ? void 0 : (_screenShotData$scree27 = screenShotData.screenshots) === null || _screenShotData$scree27 === void 0 ? void 0 : (_screenShotData$scree28 = _screenShotData$scree27.Screenshot[key - 1]) === null || _screenShotData$scree28 === void 0 ? void 0 : _screenShotData$scree28.addedAt)).format("MMM DD YYYY") !== moment(Number(screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.addedAt)).format("MMM DD YYYY") ? /*#__PURE__*/React.createElement("div", {
      className: "ScreenShots-root-date-divider-label-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ScreenShots-root-date-divider-label"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ScreenShots-root-date-divider-label-icon"
    }, /*#__PURE__*/React.createElement(GoCalendar, null)), /*#__PURE__*/React.createElement("span", null, moment().tz(currentTimezone).format("MMM DD YYYY") == moment(Number(screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.addedAt)).tz(currentTimezone).format("MMM DD YYYY") ? "Today" : moment().subtract(1, "days").tz(currentTimezone).format("MMM DD YYYY") == moment(Number(screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.addedAt)).tz(currentTimezone).format("MMM DD YYYY") ? "Yesterday" : moment(Number(screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.addedAt)).format("DD-MMM-yyyy"), " ", "Screenshots"))) : null, /*#__PURE__*/React.createElement("div", {
      //className="screenshot-card"
      className: classNames("screenshot-card", {
        "screenshot-card-non-idle": Number(screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.idleSeconds) > 0
      }, {
        "screenshot-card-selected": urls.includes(screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.imageUrl)
      }),
      key: screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.screenshotId
      // onClick={() => handleShow(screenShotvalue, key)}
      //onClick={handleShow}
    }, /*#__PURE__*/React.createElement("div", {
      className: "screenshot-card-header"
    }, /*#__PURE__*/React.createElement("img", {
      className: "screenshot-card-header-icon",
      onClick: function onClick() {
        return handleShow(screenShotvalue, key);
      },
      src: screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.appIcon
    }), /*#__PURE__*/React.createElement("div", {
      className: "screenshot-card-header-name",
      onClick: function onClick() {
        return handleShow(screenShotvalue, key);
      }
    }, screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.appTitle), /*#__PURE__*/React.createElement("div", {
      className: "screenshot-card-header-menu"
    }, editButtonForMember || editButtonAdminForMember || editButtonHeadForMember ? role == "Member" || planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" ? /*#__PURE__*/React.createElement(EditMenuIcon, {
      handleDeleteShow: handleDeleteShow,
      screenShotvalue: screenShotvalue
    }) : /*#__PURE__*/React.createElement(Form, {
      className: "image-heckbox"
    }, /*#__PURE__*/React.createElement(Form.Check, {
      inline: true,
      name: "group1",
      type: "checkbox",
      checked: urls.includes(screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.imageUrl),
      onChange: function onChange() {
        return selectedImageUrl(screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.imageUrl, screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.screenshotId, screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.thumbnailUrl);
      }
    })) : null)), /*#__PURE__*/React.createElement("div", {
      className: "screenshot-card-image",
      onClick: function onClick() {
        return handleShow(screenShotvalue, key);
      }
    }, /*#__PURE__*/React.createElement("img", {
      alt: "User Screenshot",
      className: "screenshot-card-thumbnail-image",
      src: screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.thumbnailUrl
    })), /*#__PURE__*/React.createElement("div", {
      className: "screenshot-card-footer-new",
      onClick: function onClick() {
        return handleShow(screenShotvalue, key);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "screenshot-card-footer-information-bar"
    }, /*#__PURE__*/React.createElement("div", {
      className: "screenshot-card-footer-information-bar-timer"
    }, (screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.keyCount) !== null ? /*#__PURE__*/React.createElement("div", {
      className: "screenshot-card-footer-information-bar-timer-key-count",
      title: "Shows key presses between the last and current screenshot."
    }, /*#__PURE__*/React.createElement(MdKeyboard, {
      className: "screenshot-card-footer-information-bar-timer-key-count-icon"
    }), /*#__PURE__*/React.createElement("span", null, screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.keyCount)) : null, (screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.mouseCount) !== null ? /*#__PURE__*/React.createElement("div", {
      className: "screenshot-card-footer-information-bar-timer-key-count",
      title: "Shows mouse activities between the last and current screenshot."
    }, /*#__PURE__*/React.createElement(MdMouse, {
      className: "screenshot-card-footer-information-bar-timer-key-count-icon"
    }), /*#__PURE__*/React.createElement("span", null, screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.mouseCount)) : null))), /*#__PURE__*/React.createElement("div", {
      className: "screenshot-card-footer",
      onClick: function onClick() {
        return handleShow(screenShotvalue, key);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "screenshot-card-footer-information-bar"
    }, from === "desktop" || role == "Member" ? /*#__PURE__*/React.createElement("div", {
      className: "screenshot-card-footer-name",
      title: (screenShotvalue === null || screenShotvalue === void 0 ? void 0 : (_screenShotvalue$disp = screenShotvalue.displayName) === null || _screenShotvalue$disp === void 0 ? void 0 : _screenShotvalue$disp.charAt(0).toUpperCase()) + (screenShotvalue === null || screenShotvalue === void 0 ? void 0 : (_screenShotvalue$disp2 = screenShotvalue.displayName) === null || _screenShotvalue$disp2 === void 0 ? void 0 : _screenShotvalue$disp2.slice(1))
    }, (screenShotvalue === null || screenShotvalue === void 0 ? void 0 : (_screenShotvalue$disp3 = screenShotvalue.displayName) === null || _screenShotvalue$disp3 === void 0 ? void 0 : _screenShotvalue$disp3.charAt(0).toUpperCase()) + (screenShotvalue === null || screenShotvalue === void 0 ? void 0 : (_screenShotvalue$disp4 = screenShotvalue.displayName) === null || _screenShotvalue$disp4 === void 0 ? void 0 : _screenShotvalue$disp4.slice(1))) : /*#__PURE__*/React.createElement(Link, _extends({}, _defineProperty({}, linkProps, "/personal-statistics/".concat(screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.uniqueUrl)), {
      key: "risk-".concat(screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.uniqueUrl)
    }), /*#__PURE__*/React.createElement("div", {
      className: "screenshot-card-footer-name",
      title: (screenShotvalue === null || screenShotvalue === void 0 ? void 0 : (_screenShotvalue$disp5 = screenShotvalue.displayName) === null || _screenShotvalue$disp5 === void 0 ? void 0 : _screenShotvalue$disp5.charAt(0).toUpperCase()) + (screenShotvalue === null || screenShotvalue === void 0 ? void 0 : (_screenShotvalue$disp6 = screenShotvalue.displayName) === null || _screenShotvalue$disp6 === void 0 ? void 0 : _screenShotvalue$disp6.slice(1))
    }, (screenShotvalue === null || screenShotvalue === void 0 ? void 0 : (_screenShotvalue$disp7 = screenShotvalue.displayName) === null || _screenShotvalue$disp7 === void 0 ? void 0 : _screenShotvalue$disp7.charAt(0).toUpperCase()) + (screenShotvalue === null || screenShotvalue === void 0 ? void 0 : (_screenShotvalue$disp8 = screenShotvalue.displayName) === null || _screenShotvalue$disp8 === void 0 ? void 0 : _screenShotvalue$disp8.slice(1)))), /*#__PURE__*/React.createElement("div", {
      className: "screenshot-card-footer-information-bar-timer"
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HiOutlineClock, null), /*#__PURE__*/React.createElement("span", {
      className: "screenshot-card-footer-information-bar-timer-time"
    }, moment(Number(screenShotvalue === null || screenShotvalue === void 0 ? void 0 : screenShotvalue.addedAt)).format("hh:mm A"))))))));
  })), !screenShotLoading && (screenShotData === null || screenShotData === void 0 ? void 0 : (_screenShotData$scree29 = screenShotData.screenshots) === null || _screenShotData$scree29 === void 0 ? void 0 : (_screenShotData$scree30 = _screenShotData$scree29.Screenshot) === null || _screenShotData$scree30 === void 0 ? void 0 : _screenShotData$scree30.length) > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "screenshot-load-more-button"
  }, !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore && !isLoadMoreButton ? /*#__PURE__*/React.createElement("div", {
    className: "screenshot-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      //setIsLoadMoreButton(true);
      handleLoadMore();
    }
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the screenshots")) : null), /*#__PURE__*/React.createElement(ImageViewerModal, {
    ImageViewerShow: ImageViewerShow,
    handleClose: handleClose,
    handleNext: handleNext,
    handlePrevious: handlePrevious,
    screenshotLength: screenShotData === null || screenShotData === void 0 ? void 0 : (_screenShotData$scree31 = screenShotData.screenshots) === null || _screenShotData$scree31 === void 0 ? void 0 : (_screenShotData$scree32 = _screenShotData$scree31.Screenshot) === null || _screenShotData$scree32 === void 0 ? void 0 : _screenShotData$scree32.length,
    ImageViewerNextNavCount: ImageViewerNextNavCount,
    ImageViewerPrevNavCount: ImageViewerPrevNavCount,
    from: from
  }), /*#__PURE__*/React.createElement(BulkDeleteScreenshotModal, {
    showBulkDeleteModal: showBulkDeleteModal,
    handleBulkDeleteClose: handleBulkDeleteClose,
    user: user.userId,
    url: url,
    startDate: startDateUnix,
    endDate: endDateUnix,
    role: role,
    sortBy: sortBy,
    urlIds: urlIds,
    setUrlIds: setUrlIds,
    organisationId: organisationId,
    teamId: teamId,
    setUrls: setUrls,
    startDateFilter: Number(moment(startDateFilter).format("x")),
    endDateFilter: Number(moment(endDateFilter !== null && endDateFilter !== void 0 ? endDateFilter : startDateFilter).format("x")),
    organisationSettings: organisationSettings,
    isIdleCheck: isIdleCheck,
    startTimeFilter: startTimeFilter ? moment(startTimeFilter).format("HH:mm") : null,
    endTimeFilter: endTimeFilter ? moment(endTimeFilter).format("HH:mm") : null,
    search: search,
    thumbnailUrls: thumbnailUrls,
    setThumbnailUrls: setThumbnailUrls,
    urls: urls,
    activityLevel: activityLevel
  }), /*#__PURE__*/React.createElement(DeleteScreenshotModal, {
    showDeleteModal: showDeleteModal,
    handleDeleteClose: handleDeleteClose,
    user: user.userId,
    url: url,
    startDate: Number(moment(startDate).format("x")),
    endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
    role: role,
    sortBy: sortBy,
    startDateFilter: Number(moment(startDateFilter).format("x")),
    endDateFilter: Number(moment(endDateFilter !== null && endDateFilter !== void 0 ? endDateFilter : startDateFilter).format("x")),
    organisationSettings: organisationSettings,
    isIdleCheck: isIdleCheck,
    startTimeFilter: startTimeFilter ? moment(startTimeFilter).format("HH:mm") : null,
    endTimeFilter: endTimeFilter ? moment(endTimeFilter).format("HH:mm") : null,
    search: search,
    activityLevel: activityLevel
  }));
};
var CustomToggle = /*#__PURE__*/React.forwardRef(function (_ref6, ref) {
  var children = _ref6.children,
    _onClick = _ref6.onClick,
    from = _ref6.from;
  return /*#__PURE__*/React.createElement("div", {
    className: "screenshot-activity-menu-filter-date",
    ref: ref,
    onClick: function onClick(e) {
      e.preventDefault();
      _onClick(e);
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "screenshot-activity-menu-filter-date-text \n      "
  }, children), /*#__PURE__*/React.createElement(GoChevronDown, {
    className: "screenshot-activity-menu-filter-dropdown-icon"
  }));
});
function TimeFilter(props) {
  var startDateFilter = props.startDateFilter,
    setStartDateFilter = props.setStartDateFilter,
    endDateFilter = props.endDateFilter,
    setEndDateFilter = props.setEndDateFilter,
    startTimeFilter = props.startTimeFilter,
    setStartTimeFilter = props.setStartTimeFilter,
    endTimeFilter = props.endTimeFilter,
    setEndTimeFilter = props.setEndTimeFilter,
    setShowFilter = props.setShowFilter,
    startTimeTemp = props.startTimeTemp,
    setStartTimeTemp = props.setStartTimeTemp,
    endTimeTemp = props.endTimeTemp,
    setEndTimeTemp = props.setEndTimeTemp,
    startDateTemp = props.startDateTemp,
    setStartDateTemp = props.setStartDateTemp,
    endDateTemp = props.endDateTemp,
    setEndDateTemp = props.setEndDateTemp,
    organisationBilling = props.organisationBilling,
    role = props.role;
  var format = "h:mm a";
  var now = moment().hour(0).minute(0);
  var onChangeDate = function onChangeDate(dates) {
    var _dates = _slicedToArray(dates, 2),
      start = _dates[0],
      end = _dates[1];
    setStartDateTemp(start);
    setEndDateTemp(end);
  };
  var handleFilterChange = function handleFilterChange() {
    return function () {
      // onFilterChange(dates);

      setStartDateFilter(startDateTemp);
      setEndDateFilter(endDateTemp);
      setStartTimeFilter(startTimeTemp);
      setEndTimeFilter(endTimeTemp);
      hideOverlay();
    };
  };
  var hideOverlay = function hideOverlay() {
    setShowFilter(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "screenshot-page-content-wrapper-menu-filter-overlay"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-page-content-wrapper-menu-filter-overlay-datepicker"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-page-content-wrapper-menu-filter-overlay-datepicker-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-page-content-wrapper-menu-filter-overlay-datepicker-label"
  }, "Filter by time"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MdClose, {
    className: "screenshot-page-content-wrapper-menu-filter-overlay-datepicker-close-icon",
    onClick: function onClick(e) {
      setShowFilter(false);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "screenshot-page-content-wrapper-menu-filter-overlay-timepicker-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-page-content-wrapper-menu-filter-overlay-start-timepicker screenshot-page-content-wrapper-menu-filter-overlay-timepicker"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-page-content-wrapper-menu-filter-overlay-timepicker"
  }, "Start Time "), /*#__PURE__*/React.createElement(TimePicker, {
    showSecond: false,
    defaultValue: now,
    className: "xxx",
    onChange: function onChange(e) {
      setStartTimeTemp(e);
      setShowFilter(true);
    },
    format: format,
    use12Hours: true,
    inputReadOnly: true,
    value: startTimeTemp
  })), /*#__PURE__*/React.createElement("div", {
    className: "screenshot-page-content-wrapper-menu-filter-overlay-end-timepicker screenshot-page-content-wrapper-menu-filter-overlay-timepicker"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-page-content-wrapper-menu-filter-overlay-timepicker"
  }, "End Time"), /*#__PURE__*/React.createElement(TimePicker, {
    showSecond: false,
    defaultValue: now,
    onChange: function onChange(e) {
      setEndTimeTemp(e);
      setShowFilter(true);
    },
    format: format,
    use12Hours: true,
    inputReadOnly: true,
    value: endTimeTemp,
    className: endTimeTemp < startTimeTemp ? "screenshot-page-content-wrapper-menu-filter-overlay-timepicker-end-error" : ""
  }))), /*#__PURE__*/React.createElement("div", {
    className: "screenshot-page-end-time"
  }, endTimeTemp < startTimeTemp ? "End time should be greater than the start time" : ""), /*#__PURE__*/React.createElement("div", {
    className: "screenshot-page-content-wrapper-menu-filter-overlay-button"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "screenshot-page-content-wrapper-menu-filter-overlay-button-cancel",
    variant: "outline-primary",
    onClick: hideOverlay
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "screenshot-page-content-wrapper-menu-filter-overlay-button-apply",
    onClick: handleFilterChange(),
    disabled: endTimeTemp < startTimeTemp
  }, "Apply"))));
}
var EditMenuIcon = function EditMenuIcon(props) {
  var handleDeleteShow = props.handleDeleteShow,
    screenShotvalue = props.screenShotvalue;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dropdown, {
    className: "screenshot-image-edit-menu"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    variant: "success",
    id: "dropdown-basic"
  }, /*#__PURE__*/React.createElement(HiOutlineDotsVertical, {
    className: "screenshot-image-edit-menu-icon"
  })), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    className: "project-card-delete-task",
    onClick: function onClick() {
      return handleDeleteShow(_objectSpread({}, screenShotvalue));
    }
  }, "Delete Screenshot"))));
};
var ImageViewerModal = function ImageViewerModal(props) {
  var ImageViewerShow = props.ImageViewerShow,
    handleClose = props.handleClose,
    handleNext = props.handleNext,
    handlePrevious = props.handlePrevious,
    screenshotLength = props.screenshotLength,
    ImageViewerNextNavCount = props.ImageViewerNextNavCount,
    ImageViewerPrevNavCount = props.ImageViewerPrevNavCount,
    from = props.from;
  if (ImageViewerShow == null) {
    return null;
  }
  var isWindow = typeof window !== "undefined";
  var isMobileView = window.innerWidth < 768 && from === "web";
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleClose,
    className: "screenshot-card-image-modal",
    size: "lg",
    centered: true
  }, /*#__PURE__*/React.createElement("span", {
    className: "screenshot-card-image-modal-close",
    onClick: function onClick() {
      return handleClose();
    }
  }, /*#__PURE__*/React.createElement(HiOutlineX, null)), (screenshotLength - 1 !== ImageViewerPrevNavCount || ImageViewerNextNavCount > 0 || ImageViewerShow.index != 0) && ImageViewerPrevNavCount > 0 ? /*#__PURE__*/React.createElement(GoChevronLeft, {
    className: "screenshot-card-image-modal-left-nav",
    onClick: function onClick() {
      return handlePrevious();
    },
    onKeyPress: function onKeyPress(event) {
      if (event.charCode === 37) {
        handlePrevious();
      }
    }
  }) : null, (screenshotLength - 1 !== ImageViewerNextNavCount || screenshotLength - 1 > ImageViewerPrevNavCount) && ImageViewerShow.index < screenshotLength - 1 ? /*#__PURE__*/React.createElement(GoChevronRight, {
    className: "screenshot-card-image-modal-right-nav",
    onClick: function onClick() {
      return handleNext();
    },
    onKeyPress: function onKeyPress(event) {
      if (event.keyCode === 39) {
        handleNext();
      }
    }
  }) : null, /*#__PURE__*/React.createElement(Modal.Body, {
    className: "screenshot-card-image-modal-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-card-image-modal-personal-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-card-image-modal-personal-header-details"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-card-image-modal-site-icon-content"
  }, /*#__PURE__*/React.createElement("img", {
    src: ImageViewerShow.appIcon,
    className: "screenshot-card-image-modal-site-icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "screenshot-card-image-modal-site-icon-details"
  }, /*#__PURE__*/React.createElement("span", {
    className: "screenshot-card-image-modal-site-name"
  }, ImageViewerShow.appTitle), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    className: "screenshot-card-image-modal-user-name"
  }, ImageViewerShow.displayName), isMobileView ? /*#__PURE__*/React.createElement("span", {
    className: "screenshot-card-image-modal-time"
  }, moment(Number(ImageViewerShow.addedAt)).format("hh:mm A")) : null)), isMobileView ? null : /*#__PURE__*/React.createElement("div", {
    className: "screenshot-card-image-modal-time-details"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshol-div-modal-full-content-time"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-card-image-modal-time-details-modal-timer"
  }, /*#__PURE__*/React.createElement(HiOutlineClock, {
    className: "screenshot-card-image-modal-time-icon"
  }), /*#__PURE__*/React.createElement("span", {
    className: "screenshot-card-image-modal-time"
  }, moment(Number(ImageViewerShow.addedAt)).format("LLL")))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, ImageViewerShow.keyCount !== null ? /*#__PURE__*/React.createElement("div", {
    title: "Shows key presses between the last and current screenshot.",
    className: "screenshot-card-image-modal-time-icon-key-board-margin"
  }, /*#__PURE__*/React.createElement(MdKeyboard, {
    className: "screenshot-card-image-modal-time-icon-key-board"
  }), /*#__PURE__*/React.createElement("span", {
    className: "screenshot-card-image-modal-time"
  }, "Key press count: ", ImageViewerShow.keyCount)) : null, ImageViewerShow.mouseCount !== null ? /*#__PURE__*/React.createElement("div", {
    title: "Shows mouse activities between the last and current screenshot."
  }, /*#__PURE__*/React.createElement(MdMouse, {
    className: "screenshot-card-image-modal-time-icon-key-board"
  }), /*#__PURE__*/React.createElement("span", {
    className: "screenshot-card-image-modal-time"
  }, "Mouse click count: ", ImageViewerShow.mouseCount)) : null))), /*#__PURE__*/React.createElement("div", {
    //className="screenshot-card-image-modal-screenshot-image"
    className: classNames("screenshot-card-image-modal-screenshot-image", {
      "screenshot-card-modal-non-idle": Number(ImageViewerShow === null || ImageViewerShow === void 0 ? void 0 : ImageViewerShow.idleSeconds) > 0
    })
  }, /*#__PURE__*/React.createElement("img", {
    src: ImageViewerShow.imageUrl
  }))));
};
var ScreenshotWrapper = function ScreenshotWrapper(props) {
  var _React$useContext3 = React.useContext(FilterContext),
    organisationId = _React$useContext3.organisationId,
    teamId = _React$useContext3.teamId,
    startDate = _React$useContext3.startDate,
    endDate = _React$useContext3.endDate,
    organisationSettings = _React$useContext3.organisationSettings,
    role = _React$useContext3.role,
    from = _React$useContext3.from,
    organisationBilling = _React$useContext3.organisationBilling,
    organisationStatus = _React$useContext3.organisationStatus;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  // React.useEffect(() => {
  //   if (from == "web" && role == "Member" && organisationSettings?.allowMemberToAccessTimesheet) {
  //     props?.history.push("/timesheet");
  //   }
  //   if (from == "web" && role == "Member" && organisationSettings?.manualTimeFeature) {
  //     props?.history.push("/manual-time");
  //   }
  // }, [role]);

  // && role == "Member"

  React.useEffect(function () {
    if (role === "Member" && organisationSettings.allowMemberToAccessScreenCapture == false) {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped" && from === "web" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  return role === "Admin" || role == "Head" && organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo == true ? /*#__PURE__*/React.createElement(UserSidemenu, {
    history: props.history,
    match: props.match
  }, function (user) {
    return /*#__PURE__*/React.createElement(ScreenShots, _extends({
      user: user
    }, props, {
      organisationId: organisationId,
      teamId: teamId,
      startDate: startDate,
      endDate: endDate,
      organisationSettings: organisationSettings,
      role: role,
      from: from,
      planId: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId,
      planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
      organisationBilling: organisationBilling
    }));
  }) : /*#__PURE__*/React.createElement(ScreenShots, _extends({
    user: null
  }, props, {
    organisationId: organisationId,
    teamId: teamId,
    startDate: startDate,
    endDate: endDate,
    organisationSettings: organisationSettings,
    role: role,
    planId: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId,
    organisationBilling: organisationBilling
  }));
};
var BulkDeleteScreenshotModal = function BulkDeleteScreenshotModal(props) {
  var showBulkDeleteModal = props.showBulkDeleteModal,
    handleBulkDeleteClose = props.handleBulkDeleteClose,
    user = props.user,
    url = props.url,
    startDate = props.startDate,
    endDate = props.endDate,
    role = props.role,
    sortBy = props.sortBy,
    setUrlIds = props.setUrlIds,
    urlIds = props.urlIds,
    organisationId = props.organisationId,
    teamId = props.teamId,
    setUrls = props.setUrls,
    startDateFilter = props.startDateFilter,
    endDateFilter = props.endDateFilter,
    organisationSettings = props.organisationSettings,
    isIdleCheck = props.isIdleCheck,
    startTimeFilter = props.startTimeFilter,
    endTimeFilter = props.endTimeFilter,
    search = props.search,
    setThumbnailUrls = props.setThumbnailUrls,
    thumbnailUrls = props.thumbnailUrls,
    urls = props.urls,
    activityLevel = props.activityLevel;
  if (showBulkDeleteModal === null && urlIds.length === 0) {
    return null;
  }
  var _React$useState55 = React.useState(null),
    _React$useState56 = _slicedToArray(_React$useState55, 2),
    deleteStatus = _React$useState56[0],
    setDeleteStatus = _React$useState56[1];
  var _useMutation = useMutation(DELETE_BULK_SCREENSHOT_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    deleteBulkScreenshot = _useMutation2[0],
    deleteScreenshotLoading = _useMutation2[1].loading;
  var handleDeleteProject = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var _response$data, response;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!deleteScreenshotLoading) {
            _context3.next = 2;
            break;
          }
          return _context3.abrupt("return");
        case 2:
          _context3.prev = 2;
          _context3.next = 5;
          return deleteBulkScreenshot({
            variables: {
              screenshotId: urlIds,
              organisationId: organisationId,
              teamId: teamId,
              screenshotUrls: [].concat(_toConsumableArray(urls), _toConsumableArray(thumbnailUrls))
            },
            // update(cache, { data }) {
            //   if (!data?.deleteBulkScreenshot) return;

            //   // console.log({ data })

            //   const version = Date.now();

            //   cache.modify({
            //     fields: {
            //       screenshots(existing = {}) {
            //         if (!existing.Screenshot) return existing;
            //         // console.log({ existing })

            //         // console.log({ urlIds })
            //         return {
            //           ...existing,
            //           Screenshot: existing.Screenshot.map(screenshot => {
            //             if (!urlIds.includes(screenshot.screenshotId)) {
            //               return screenshot;
            //             }

            //             // console.log({ screenshot })

            //             return {
            //               ...screenshot,
            //               imageUrl: `${screenshot.imageUrl}?v=${version}`,
            //               thumbnailUrl: screenshot.thumbnailUrl
            //                 ? `${screenshot.thumbnailUrl}?v=${version}`
            //                 : null,
            //             };
            //           }),
            //         };
            //       },
            //     },
            //   });
            // },
            awaitRefetchQueries: true,
            // by operation name, not {query, variables}: a hand-copied variable list
            // has to match the watched query's variables exactly or Apollo refetches a
            // different cache entry and the screen never updates. This refetches
            // whatever ScreenshotData is currently active, with its own variables.
            refetchQueries: ["ScreenshotData"]
          });
        case 5:
          response = _context3.sent;
          if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.deleteBulkScreenshot) {
            _context3.next = 10;
            break;
          }
          setDeleteStatus("error");
          toast.error("Error Occured, Try again later!");
          return _context3.abrupt("return");
        case 10:
          setDeleteStatus(true);
          setUrlIds([]);
          setUrls([]);
          setThumbnailUrls([]);
          toast.success("Screenshots deleted successfully!");
          handleBulkDeleteClose();
          _context3.next = 24;
          break;
        case 18:
          _context3.prev = 18;
          _context3.t0 = _context3["catch"](2);
          console.error("Delete screenshot failed:", _context3.t0);

          // 🔥 Timeout / network handling
          if (_context3.t0 !== null && _context3.t0 !== void 0 && _context3.t0.networkError) {
            toast.error("Network timeout. Please try again.");
          } else {
            toast.error("Error occurred. Try again later.");
          }
          handleBulkDeleteClose();
          setDeleteStatus("error");
        case 24:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[2, 18]]);
  })), [deleteBulkScreenshot, deleteScreenshotLoading, urlIds]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: showBulkDeleteModal,
    onHide: handleBulkDeleteClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Delete Screenshot")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, "Are you sure to delete the selected ", urlIds.length === 1 ? "screenshot" : "screenshots", "? Deleted", " ", urlIds.length === 1 ? "screenshot" : "screenshots", " can't be retrieved.", /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-card-delete-task-name-text"
  }, " ", "It will take a few seconds to delete the screenshot in our cloud.")), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleBulkDeleteClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: function onClick() {
      return handleDeleteProject();
    },
    disabled: deleteScreenshotLoading
  }, deleteStatus === true ? "Deleted" : deleteScreenshotLoading ? "Deleting" : urlIds.length === 1 ? "Delete Screenshot" : "Delete Screenshots")));
};
var DeleteScreenshotModal = function DeleteScreenshotModal(props) {
  var showDeleteModal = props.showDeleteModal,
    handleDeleteClose = props.handleDeleteClose,
    user = props.user,
    url = props.url,
    startDate = props.startDate,
    endDate = props.endDate,
    role = props.role,
    sortBy = props.sortBy,
    startDateFilter = props.startDateFilter,
    endDateFilter = props.endDateFilter,
    organisationSettings = props.organisationSettings,
    isIdleCheck = props.isIdleCheck,
    startTimeFilter = props.startTimeFilter,
    endTimeFilter = props.endTimeFilter,
    search = props.search,
    activityLevel = props.activityLevel;
  if (showDeleteModal === null) {
    return null;
  }
  var screenshotId = showDeleteModal.screenshotId,
    appTitle = showDeleteModal.appTitle,
    organisationId = showDeleteModal.organisationId,
    teamId = showDeleteModal.teamId,
    imageUrl = showDeleteModal.imageUrl,
    thumbnailUrl = showDeleteModal.thumbnailUrl;
  var _React$useState57 = React.useState(null),
    _React$useState58 = _slicedToArray(_React$useState57, 2),
    deleteStatus = _React$useState58[0],
    setDeleteStatus = _React$useState58[1];
  var _useMutation3 = useMutation(DELETE_BULK_SCREENSHOT_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    deleteBulkScreenshot = _useMutation4[0],
    deleteScreenshotLoading = _useMutation4[1].loading;
  var handleDeleteProject = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var _response$data2, response;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!deleteScreenshotLoading) {
            _context4.next = 2;
            break;
          }
          return _context4.abrupt("return");
        case 2:
          _context4.prev = 2;
          _context4.next = 5;
          return deleteBulkScreenshot({
            variables: {
              screenshotId: [screenshotId],
              organisationId: organisationId,
              teamId: teamId,
              screenshotUrls: [imageUrl, thumbnailUrl]
            },
            awaitRefetchQueries: true,
            // by operation name, not {query, variables}: a hand-copied variable list
            // has to match the watched query's variables exactly or Apollo refetches a
            // different cache entry and the screen never updates. This refetches
            // whatever ScreenshotData is currently active, with its own variables.
            refetchQueries: ["ScreenshotData"]
          });
        case 5:
          response = _context4.sent;
          if (response !== null && response !== void 0 && (_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.deleteBulkScreenshot) {
            _context4.next = 10;
            break;
          }
          setDeleteStatus("error");
          toast.error("Error Occured, Try again later!");
          return _context4.abrupt("return");
        case 10:
          setDeleteStatus(true);
          toast.success("Screenshots deleted successfully!");
          handleDeleteClose();
          _context4.next = 21;
          break;
        case 15:
          _context4.prev = 15;
          _context4.t0 = _context4["catch"](2);
          console.error("Delete screenshot failed:", _context4.t0);

          // 🔥 Timeout / network handling
          if (_context4.t0 !== null && _context4.t0 !== void 0 && _context4.t0.networkError) {
            toast.error("Network timeout. Please try again.");
          } else {
            toast.error("Error occurred. Try again later.");
          }
          handleDeleteClose();
          setDeleteStatus("error");
        case 21:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[2, 15]]);
  })), [deleteBulkScreenshot, deleteScreenshotLoading]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: showDeleteModal,
    onHide: handleDeleteClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Delete Screenshot")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, "Are you sure you want to delete screenshot", " ", /*#__PURE__*/React.createElement("span", {
    className: "project-details-task-card-delete-task-name"
  }, appTitle, "?")), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleDeleteClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: function onClick() {
      return handleDeleteProject();
    },
    disabled: deleteScreenshotLoading
  }, deleteStatus === true ? "Deleted" : deleteScreenshotLoading ? "Deleting" : "Delete Screenshot")));
};
var ScreenShotEnableSection = function ScreenShotEnableSection(props) {
  var organisationId = props.organisationId,
    teamId = props.teamId,
    role = props.role,
    user = props.user,
    url = props.url,
    startDate = props.startDate,
    endDate = props.endDate,
    sortBy = props.sortBy,
    startDateFilter = props.startDateFilter,
    endDateFilter = props.endDateFilter,
    organisationSettings = props.organisationSettings,
    isIdleCheck = props.isIdleCheck,
    startTimeFilter = props.startTimeFilter,
    endTimeFilter = props.endTimeFilter,
    search = props.search,
    activityLevel = props.activityLevel;
  var _useMutation5 = useMutation(ADD_SCREENSHOT_WORK_DAY_SETTINGS_MUTATION),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    addScreenshotWorkDaySettings = _useMutation6[0],
    screenshotLoading = _useMutation6[1].loading;
  var handleEnableScreenCapture = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var response;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          if (!screenshotLoading) {
            _context5.next = 2;
            break;
          }
          return _context5.abrupt("return");
        case 2:
          _context5.next = 4;
          return addScreenshotWorkDaySettings({
            variables: {
              organisationId: organisationId,
              feature: "screenCapture"
            },
            awaitRefetchQueries: true,
            refetchQueries: [
            // see the note on the delete handlers: by name so it tracks the active
            // query's own variables instead of a copy that can drift
            "ScreenshotData", {
              query: WEB_ORGANISATION_SETTINGS_QUERY,
              variables: {
                organisationId: organisationId
              }
            }, {
              query: WORK_DAY_SETTINGS_QUERY,
              variables: {
                organisationId: organisationId
              }
            }]
          });
        case 4:
          response = _context5.sent;
          if (!(!response || !response.data || response.data.addScreenshotWorkDaySettings === false)) {
            _context5.next = 9;
            break;
          }
          throw new Error("error");
        case 9:
          toast.success("Setting enabled successfully!");
        case 10:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  })), [addScreenshotWorkDaySettings, screenshotLoading]);
  return /*#__PURE__*/React.createElement("div", {
    className: "screenshot-card-warning-text-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-card-warning-text"
  }, /*#__PURE__*/React.createElement("p", {
    className: "timelapse-warning-text-p"
  }, " ", "Hello ", user.displayName, ", you are yet to enable the screen capture feature.", " "), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "screenshot-enble-page",
    disabled: screenshotLoading,
    onClick: function onClick() {
      return handleEnableScreenCapture();
    }
  }, screenshotLoading ? "Updating..." : "Click to enable screen capture")));
};
export default ScreenshotWrapper;